import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import Bird from '../animations/Bird';
import CupStackGame from '../game/CupStackGame';
import PausePopup, { PAUSE_POPUP_EVENTS } from '../game/PausePopup';
import gameData from '../gameData';
import Keyboard from '../keyboard/Keyboard';
import SoundAssetKeys from '../SoundAssetKeys';
import ScoreBox from '../ui/ScoreBox';
import UIAssetKeys from '../UIAssetKeys';
import EndScreen from './EndScreen';
import { getGameBackground } from './GameBackground';
import Intro from './Intro';

export default class Game extends Phaser.Scene
{
    static get KEY() { return 'Game'; }

    constructor()
    {
        super({ key: (Game).KEY });
    }

    create()
    {
        this.elapsedTime = 0;
        this.pausePopupOpen = false;

        this.scoreBox = new ScoreBox(this, gameData.isMobile ? this.scale.width / 2 - 200 : this.scale.width / 2 - 339, 55);

        this.muteGame = false;

        this.menuButton = ABCyaPhaser.Buttons.addSimpleButton(this.scale.width - 17, 17, UIAssetKeys._game_items_btnInfo_0, null, () => this.toggleGameState(), this).setOrigin(1, 0);

        this.muteButton = ABCyaPhaser.Buttons.addSimpleButton(this.menuButton.x - this.menuButton.width - 15, 17, UIAssetKeys._game_items_speaker_on_0, null, () =>
        {
            this.muteGame = !this.muteGame;
            this.sound.setMute(this.muteGame);
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
            if (this.muteGame)
            {
                this.muteButton.setFrame(UIAssetKeys._game_items_speaker_off_0);
                this.muteButton._downFrame = UIAssetKeys._game_items_speaker_off_0;
            }
            else
            {
                this.muteButton.setFrame(UIAssetKeys._game_items_speaker_on_0);
                this.muteButton._downFrame = UIAssetKeys._game_items_speaker_on_0;
            }
        }, this).setOrigin(1, 0);

        this.keyBoard = new Keyboard(this, this.scale.width / 2, 0);
        this.keyBoard.on("KEY_PRESS", this.handleKeyboard, this);
        this.keysShown = false;

        this.startGameScreen();

        this.round = 1;

        this._pausePopup = new PausePopup(this, this.scale.width / 2, this.scale.height / 2 + (gameData.isMobile ? -100 : 10)).setAlpha(0).setDepth(10);
        this._pausePopup.on(PAUSE_POPUP_EVENTS.resume, () => this.toggleGameState());
        this._pausePopup.on(PAUSE_POPUP_EVENTS.quit, () =>
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
            this.time.removeAllEvents();

            this.muteButton.disableInteractive();
            this.menuButton.disableInteractive();

            getGameBackground().pan("up");

            this.tweens.killTweensOf(this._pausePopup);
            this._pausePopup.disableButtons();
            ABCyaPhaser.Tweens.addTween(this._pausePopup, 250, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);

            this.hideKeys();

            ABCyaPhaser.Tweens.addTween([this.stackGame, this.scoreBox, this.menuButton, this.muteButton], 250, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out);

            this.time.delayedCall(1800, () => this.scene.start(Intro.KEY));
        });

        //ABCyaPhaser.Debug.addScreenReference(this, "ref", "assets/3 Gameplay-01.png")
        //ABCyaPhaser.Debug.addScreenReference(this, "ref", "assets/4 Pause-01.png")
    }

    toggleGameState()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);
        this.tweens.killTweensOf(this._pausePopup);
        if (!this.pausePopupOpen) 
        {
            this.pausePopupOpen = true;
            ABCyaPhaser.Tweens.addTween(this._pausePopup, 250, { alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => this._pausePopup.enableButtons());
        }
        else
        {
            this._pausePopup.disableButtons();
            ABCyaPhaser.Tweens.addTween(this._pausePopup, 250, { alpha: 0 }, Phaser.Math.Easing.Quadratic.Out, () => this.pausePopupOpen = false);
        }
    }

    startGameScreen()
    {
        //start round
        getGameBackground().pan("stop");
        this.stackGame = new CupStackGame(this);
        this.add.existing(this.stackGame);
        this.stackGame.once("GAME_COMPLETE", this.handleGameComplete, this);
        this.stackGame.on("CONTROL_KEYS", this.controlKeys, this);
        this.stackGame.on("END_LEVEL", this.handleLevelEnd, this);
        this.stackGame.on("START_LEVEL", this.handleLevelStart, this);
        this.stackGame.startGame();

        this.totalGameTime = 0;
    }

    handleLevelStart()
    {
        if (this.bird)
        {
            this.bird.destroy();
            this.bird = null;
        }
        this.elapsedTime = 0;
        this.gamePaused = false;
        this.scoreBox.alpha = 1;
        if (this.keyBoard.isActive == false) this.showKeys();
    }

    handleLevelEnd()
    {
        this.gamePaused = true;
        this.totalGameTime += this.elapsedTime;
        this.scoreBox.alpha = 0;

        this.round++;
        this.scoreBox.updateRound(this.round);

        this.bird = new Bird(this, 0, 0);
        this.bird.x = -(this.bird.body.width + 100);
        this.bird.y = Phaser.Math.Between((this.scale.height / 2) - 100, (this.scale.height / 2) + 100);
        this.bird.flyTo(this.scale.width + 100, Phaser.Math.Between(-200, this.scale.height), 1300);
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._bird_jump_fly_tween, this);
    }

    controlKeys(e)
    {
        if (e._showFlag == true && this.keysShown == false) this.showKeys();
        if (e._showFlag == false && this.keysShown == true) this.hideKeys();
    }

    showKeys()
    {
        this.keysShown = true;
        this.keyBoard.controlKeysShown(true);
    }

    hideKeys()
    {
        this.keyBoard.controlKeysShown(false);
    }

    handleKeyboard(e)
    {
        if (!this.gamePaused && !this.pausePopupOpen && e._keyValue != null) this.stackGame.keyInput(e._keyValue);
    }

    handleGameComplete()
    {
        this.gamePaused = true;
        this.scoreBox.alpha = 0;
        this.hideKeys();
        this.totalGameTime += this.elapsedTime;
        gameData.gameTime = this.totalGameTime;
        if (gameData.bestTime == 0 || this.totalGameTime < gameData.bestTime) gameData.bestTime = this.totalGameTime;
        this.endGameScreen();
    }

    update(time, delta)
    {
        if (this.gamePaused == false && this.pausePopupOpen == false)
        {
            this.elapsedTime += delta / 1000;
            let showTime = Math.round(this.totalGameTime + this.elapsedTime);
            if (this.scoreBox.scoreNum != showTime) this.scoreBox.updateScore(showTime);
        }
    }

    endGameScreen()
    {
        getGameBackground().pan("right", 15);
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._basket_menu_tween, this);
        this.time.delayedCall(1500, this.cleanUp, null, this);
    }

    cleanUp()
    {
        getGameBackground().pan("stop");

        this.scene.start(EndScreen.KEY);
    }
}